// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import Link from "next/link";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: {
        hd: BsCss.justifyContent("center"),
        tl: {
          hd: BsCss.alignItems("center"),
          tl: {
            hd: BsCss.textAlign("center"),
            tl: {
              hd: BsCss.marginTop(BsCss.px(100)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var title = Curry._1(BsCss.style, {
      hd: BsCss.color(BsCss.hex("313E49")),
      tl: {
        hd: BsCss.fontSize(BsCss.px(42)),
        tl: {
          hd: BsCss.fontWeight({
                NAME: "num",
                VAL: 600
              }),
          tl: {
            hd: BsCss.lineHeight(BsCss.px(52)),
            tl: /* [] */0
          }
        }
      }
    });

var text = Curry._1(BsCss.style, {
      hd: BsCss.color(BsCss.hex("767676")),
      tl: {
        hd: BsCss.fontSize(BsCss.px(16)),
        tl: {
          hd: BsCss.fontWeight({
                NAME: "num",
                VAL: 400
              }),
          tl: {
            hd: BsCss.lineHeight(BsCss.px(25)),
            tl: /* [] */0
          }
        }
      }
    });

var button = Curry._1(BsCss.style, {
      hd: BsCss.color(BsCss.hex("FFFFFF")),
      tl: {
        hd: BsCss.backgroundColor(BsCss.hex("E30B17")),
        tl: {
          hd: BsCss.fontSize(BsCss.px(16)),
          tl: {
            hd: BsCss.fontWeight({
                  NAME: "num",
                  VAL: 700
                }),
            tl: {
              hd: BsCss.lineHeight(BsCss.px(17)),
              tl: {
                hd: BsCss.width(BsCss.px(250)),
                tl: {
                  hd: BsCss.height(BsCss.px(50)),
                  tl: {
                    hd: BsCss.borderRadius(BsCss.px(10)),
                    tl: {
                      hd: BsCss.marginTop(BsCss.px(25)),
                      tl: {
                        hd: BsCss.hover({
                              hd: BsCss.opacity(0.50),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  title: title,
  text: text,
  button: button
};

function AboutJoinTeam(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h1", {
                            children: Util.ReactStuff.s("Want to join the team?"),
                            className: title
                          }),
                      JsxRuntime.jsx("br", {}),
                      JsxRuntime.jsx("p", {
                            children: Util.ReactStuff.s("We're hiring right across the globe!"),
                            className: text
                          }),
                      JsxRuntime.jsx("p", {
                            children: Util.ReactStuff.s("Take a look at our latest career opportunities."),
                            className: text
                          }),
                      JsxRuntime.jsx(Link, {
                            href: "https://boards.greenhouse.io/prezzee",
                            prefetch: false,
                            children: JsxRuntime.jsx("a", {
                                  children: JsxRuntime.jsx("button", {
                                        children: Util.ReactStuff.s("Join us"),
                                        className: button
                                      }),
                                  target: "_blank"
                                })
                          })
                    ]
                  }),
              className: container
            });
}

var Link$1;

var make = AboutJoinTeam;

export {
  Link$1 as Link,
  Styles ,
  make ,
}
/* container Not a pure module */
